import {
  TableCell,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputAdornment,
  Box,
} from "@mui/material";
import { useState, useEffect } from "react";
import { isValidDecimalInput } from "@/utils/inputParse";

interface LossParameterFieldProps {
  name: string;
  value: number | string;
  onChange: (value: number) => void;
  onUnitChange?: (isPct: boolean) => void;
  lossType?: string;
  isPct?: boolean;
  colSpan?: number;
}

const LossParameterField = ({
  name,
  value,
  onChange,
  onUnitChange,
  lossType = "pct",
  isPct = true,
  colSpan = 2,
}: LossParameterFieldProps) => {
  const [inputVal, setInputVal] = useState(Number(value ?? 0).toFixed(2));

  useEffect(() => {
    setInputVal(Number(value ?? 0).toFixed(2));
  }, [value]);

  const handleChange = (val: string) => {
    if (isValidDecimalInput(val, 2)) {
      setInputVal(val);
    }
  };

  const handleBlur = () => {
    const num = inputVal === "" ? 0 : parseFloat(inputVal) || 0;
    setInputVal(num.toFixed(2));
    onChange(num);
  };

  if (lossType === "mix" && onUnitChange) {
    return (
      <TableCell colSpan={colSpan}>
        <Box display="flex" gap={1} width="100%">
          <TextField
            size="small"
            sx={{ width: "40%" }}
            placeholder="Value"
            value={inputVal}
            onChange={(e) => handleChange(e.target.value)}
            onBlur={handleBlur}
          />
          <FormControl size="small" sx={{ width: "60%" }}>
            <Select
              value={isPct ? "%" : "THB/pcs"}
              onChange={(e) => onUnitChange(e.target.value === "%")}
            >
              <MenuItem value="%">%</MenuItem>
              <MenuItem value="THB/pcs">THB/pcs</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </TableCell>
    );
  }

  return (
    <TableCell colSpan={colSpan}>
      <TextField
        size="small"
        fullWidth
        placeholder={name}
        value={inputVal}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={handleBlur}
        sx={{ "& input": { textAlign: "right" } }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                {lossType === "pct" ? "%" : "THB"}
              </InputAdornment>
            ),
          },
        }}
      />
    </TableCell>
  );
};

export default LossParameterField;